/** Preserve cents and use the currency returned by the enrichment API.
 *  Missing currency is unavailable, never an implicit dollar or euro amount. */
export function formatEnrichmentMoney(
  amount: number | null | undefined,
  currency: string | null | undefined,
  maximumFractionDigits = 2,
): string {
  if (amount == null || !Number.isFinite(amount) || !currency) return "—";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits,
  }).format(amount);
}

/** Currency symbols in the rate editor come from the same API currency. */
export function enrichmentCurrencySymbol(currency: string | null | undefined): string {
  if (!currency) return "—";
  return new Intl.NumberFormat("en-US", { style: "currency", currency })
    .formatToParts(0)
    .find((part) => part.type === "currency")?.value ?? currency;
}
